import { DropdownItem, TextBase } from '@carboncopyco/ui';
import type React from 'react';

type RowOptionsItemProps = {
  label: string;
  iconLeft: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
};

export const RowOptionsItem = ({
  label,
  iconLeft,
  onClick,
  disabled,
}: RowOptionsItemProps) => (
  <DropdownItem
    label={
      <TextBase
        label={label}
        color="text-ds-natural-600"
      />
    }
    iconLeft={<div className="text-ds-natural-600">{iconLeft}</div>}
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
  />
);
